module.exports = __webpack_public_path__ + "static/img/psisteps.8f0955a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/psisteps.png
// module id = jDUw
// module chunks = 1